import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Popup from '../../components/Popup/Popup';
import ReadMore from '../../components/ReadMore/ReadMore';
import Price from '../Price/Price';
import {
  CardWrapperStyled,
  DescriptionStyled,
  DetailsTitleStyled,
  Divider,
  GoalStyled,
  ImageStyled,
  ImageWrapperStyled,
  LeftColStyled,
  MetadataWrapperStyled,
  OwnerNameStyled,
  PopupImageStyled,
  RightColStyled,
  RowStyled,
  ShortDescriptionWrapperStyled,
  SustainableActionDetailsStyled,
} from './DetailsCard.styled';

export type DetailsCardPropsT = {
  title: string;
  description: string;
  imageUrl: string;
  childrenMeta: React.ReactNode;
  childrenRightCol: React.ReactNode;
  projectOwner?: string;
  goalPrice?: number;
  raisedPrice?: number;
  maxCharacters?: number;
  rowsNumber?: number;
};

const DetailsCard: React.FC<DetailsCardPropsT> = ({
  title,
  childrenMeta,
  description,
  imageUrl,
  childrenRightCol,
  projectOwner,
  goalPrice,
  raisedPrice,
  maxCharacters,
  rowsNumber,
}) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const isSustainableDetailsShow = !!projectOwner || !!goalPrice || !!raisedPrice;

  return (
    <>
      <CardWrapperStyled>
        <LeftColStyled>
          <ImageStyled src={imageUrl} alt="found item image" />

          <div>
            <DetailsTitleStyled level={4}>{title}</DetailsTitleStyled>

            <Divider />

            <MetadataWrapperStyled>{childrenMeta}</MetadataWrapperStyled>

            <ShortDescriptionWrapperStyled>
              <ReadMore
                onClick={() => setPopupOpen(true)}
                text={description}
                maxCharacters={maxCharacters}
                rowsNumber={rowsNumber}
              />
            </ShortDescriptionWrapperStyled>
          </div>
        </LeftColStyled>

        <RightColStyled>{childrenRightCol}</RightColStyled>
      </CardWrapperStyled>

      <Popup isOpen={isPopupOpen} onClose={() => setPopupOpen(false)}>
        <>
          <DetailsTitleStyled level={3}>{title}</DetailsTitleStyled>

          <ImageWrapperStyled>
            <PopupImageStyled src={imageUrl} alt="test" />

            {isSustainableDetailsShow && (
              <SustainableActionDetailsStyled>
                <GoalStyled>
                  <FormattedMessage id="statusCard.goal" defaultMessage="Goal" />:{' '}
                  <Price isFormatted amount={goalPrice || 0} />
                </GoalStyled>
                <RowStyled>
                  <FormattedMessage id="statusCard.raisedToDate" defaultMessage="Raised to date" />:{' '}
                  <Price isFormatted amount={raisedPrice || 0} />
                </RowStyled>

                <RowStyled>
                  <FormattedMessage id="statusCard.projectOwner" defaultMessage="Project Owner" />:
                  <OwnerNameStyled>{projectOwner}</OwnerNameStyled>
                </RowStyled>
              </SustainableActionDetailsStyled>
            )}
          </ImageWrapperStyled>

          <DescriptionStyled>
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
          </DescriptionStyled>
        </>
      </Popup>
    </>
  );
};

export default DetailsCard;
